/**
* Extensions.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { objFreeze } from "@microsoft/applicationinsights-core-js";
export var Extensions = objFreeze({
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SdkExt: "sdk",
    IntWebExt: "intweb",
    UtcExt: "utc",
    LocExt: "loc",
    CloudExt: "cloud"
});
//# sourceMappingURL=Extensions.js.map